// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/transceiver.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { SignalDescriptor, SignalDescriptorJson } from "./signal_descriptor_pb";
import { file_mochabugapis_adapt_graph_signal_descriptor } from "./signal_descriptor_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/transceiver.proto.
 */
export const file_mochabugapis_adapt_graph_transceiver: GenFile = /*@__PURE__*/
  fileDesc("Ciptb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvdHJhbnNjZWl2ZXIucHJvdG8SGG1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaCLGAgoLVHJhbnNjZWl2ZXISLQoEbmFtZRgBIAEoCUIfukgcchoQARgyMhReW18kYS16XVtfJGEtejAtOV0qJBIiCgtkZXNjcmlwdGlvbhgCIAEoCUIIukgFcgMY+gFIAIgBARKtAQoHc2lnbmFscxgDIAMoCzIqLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5TaWduYWxEZXNjcmlwdG9yQnC6SG26AWQKFHNpZ25hbHNfdW5pcXVlX25hbWVzEiRFYWNoIHNpZ25hbCBtdXN0IGhhdmUgYSB1bmlxdWUgbmFtZS4aJnRoaXMubWFwKHNpZ25hbCwgc2lnbmFsLm5hbWUpLnVuaXF1ZSgpkgEDEIAEEhYKCXN0cmVhbWluZxgEIAEoCEgBiAEBQg4KDF9kZXNjcmlwdGlvbkIMCgpfc3RyZWFtaW5nYgZwcm90bzM", [file_buf_validate_validate, file_mochabugapis_adapt_graph_signal_descriptor]);

/**
 * Transceiver is a dual-purpose entity capable of both emitting and receiving signals.
 *
 * @generated from message mochabugapis.adapt.graph.Transceiver
 */
export type Transceiver = Message<"mochabugapis.adapt.graph.Transceiver"> & {
  /**
   * Identifier for the transceiver, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Optional descriptive text for the transceiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * List of signals the transceiver handles. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.SignalDescriptor signals = 3;
   */
  signals: SignalDescriptor[];

  /**
   * Wheter or not the transceiver is a streaming transceiver.
   *
   * @generated from field: optional bool streaming = 4;
   */
  streaming?: boolean;
};

/**
 * Transceiver is a dual-purpose entity capable of both emitting and receiving signals.
 *
 * @generated from message mochabugapis.adapt.graph.Transceiver
 */
export type TransceiverJson = {
  /**
   * Identifier for the transceiver, following the ECMA naming pattern, limited to 50 characters.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * Optional descriptive text for the transceiver's purpose, up to 250 characters.
   *
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * List of signals the transceiver handles. Can contain up to 512 unique signals.
   *
   * @generated from field: repeated mochabugapis.adapt.graph.SignalDescriptor signals = 3;
   */
  signals?: SignalDescriptorJson[];

  /**
   * Wheter or not the transceiver is a streaming transceiver.
   *
   * @generated from field: optional bool streaming = 4;
   */
  streaming?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.graph.Transceiver.
 * Use `create(TransceiverSchema)` to create a new message.
 */
export const TransceiverSchema: GenMessage<Transceiver, TransceiverJson> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_transceiver, 0);

